/**
 * Asynchronously loads the component for CourseWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./CourseWidgetContainer'),
  loading: () => null,
});
